<!-- 解决方案 -->
<template>
  <div class="dtwin-solution-container">
    <div class="dtwin-solution-wrapper">
      <header
        class="dtwin-solution-hd"
        v-scroll-animate="{
          animation: 'fadeInUp',
        }"
      >
        {{ title }}
      </header>
      <article
        class="dtwin-solution-bd text-wrap"
        v-scroll-animate="{
          animation: 'fadeInUp',
          delay: 200,
        }"
      >
        {{ desc }}
      </article>
    </div>
  </div>
</template>

<script>
export default {
  name: "Solution",
  components: {},
  data() {
    return {
      title:
        "Digital Twin Solution for Infrastructure Operation and Maintenance",
      desc: "Digital twin base is a technology framework for creating, digital twin models and connecting them to actual physical systems or processes. It combines the physical and digital worlds to provide intelligent monitoring, optimization and prediction capabilities for real systems through real-time data acquisition, model simulation and analysis. The digital twin base has a wide range of application areas, Delauney has used it in road transportation, waterway and urban planning businesses. Through the digital twin base, it can realize the comprehensive monitoring, and control of the actual system, improve the operation efficiency, reduce the maintenance cost, and provide decision support for the future development of the system.",
    };
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style scoped lang="scss">
@import "@/assets/styles/common.scss";
.dtwin-solution-container {
  padding: 80px 0;
  background: #fff;
  .dtwin-solution-wrapper {
    width: 1200px;
    margin: 0 auto;
  }

  .dtwin-solution-hd {
    margin-bottom: 24px;
    font-weight: bold;
    font-size: 32px;
    color: #333;
    line-height: 24px;
    text-align: center;
    font-style: normal;
  }
  .dtwin-solution-bd {
    font-weight: 400;
    font-size: 18px;
    color: #333;
    line-height: 40px;
    text-align: justify;
    font-style: normal;
  }
}
</style>
